import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Checkbox,
} from "@mui/material";
import apiClient from "../../../utils/apiClient";
import CustomButton from "../../custom/CustomButton";
import { showSuccessToast, showErrorToast } from "../../../utils/swalToast";

// Dedicated "which roles can see this menu" action, separate from Edit Menu.
// PUT must echo the menu's other fields back since updateMenu replaces them.
const MenuRolesModal = ({ open, onClose, menu, roles, onSuccess }) => {
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && menu) {
      setSelectedRoleIds(menu.roleIds || []);
    }
  }, [open, menu]);

  const toggleRole = (roleId) => {
    setSelectedRoleIds((prev) =>
      prev.includes(roleId) ? prev.filter((id) => id !== roleId) : [...prev, roleId]
    );
  };

  const handleSave = async () => {
    if (!menu) return;
    setSaving(true);
    try {
      await apiClient.put(
        `/access-control/menus/${menu.id}`,
        {
          label: menu.label,
          path: menu.path,
          icon: menu.icon,
          order: menu.order,
          parent_id: menu.parent_id,
          roleIds: selectedRoleIds,
        }
      );
      showSuccessToast("Akses menu berhasil disimpan");
      onSuccess();
    } catch (error) {
      showErrorToast(error?.response?.data?.msg || "Terjadi kesalahan");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Kelola Akses Menu
        <Typography variant="body2" color="text.secondary">
          {menu?.label}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 2 }}>Pilih role yang boleh melihat menu ini.</Typography>
        {roles.map((role) => (
          <Box
            key={role.id}
            onClick={() => toggleRole(role.id)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              px: 2,
              py: 1,
              mb: 1.5,
              cursor: "pointer",
              "&:hover": { backgroundColor: "rgba(0,49,88,0.04)" },
            }}
          >
            <Checkbox
              checked={selectedRoleIds.includes(role.id)}
              onChange={() => toggleRole(role.id)}
              onClick={(e) => e.stopPropagation()}
            />
            <Box>
              <Typography fontWeight={600}>{role.name}</Typography>
              <Typography variant="caption" color="text.secondary">
                {role.code}
              </Typography>
            </Box>
          </Box>
        ))}
      </DialogContent>
      <DialogActions sx={{ padding: "15px 24px", gap: 1 }}>
        <CustomButton
          text="Batal"
          baseColor="#A92027"
          hoverColor="#8C1016"
          isFullWidth={false}
          onClick={onClose}
          disabled={saving}
        />
        <CustomButton
          text={saving ? "Menyimpan..." : "Simpan"}
          baseColor="#003158"
          hoverColor="#00213A"
          isFullWidth={false}
          onClick={handleSave}
          disabled={saving}
        />
      </DialogActions>
    </Dialog>
  );
};

export default MenuRolesModal;
